'use client';

import type { Birthday } from '@/lib/types';
import { BirthdayCard } from './birthday-card';
import { Card, CardContent } from './ui/card';

type BirthdayListProps = {
  birthdays: Birthday[];
  title: string;
  emptyMessage: string;
};

export function BirthdayList({
  birthdays,
  title,
  emptyMessage,
}: BirthdayListProps) {
  if (birthdays.length === 0) {
    return (
      <Card>
        <CardContent className="pt-6">
          <p className="text-center text-muted-foreground">{emptyMessage}</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {birthdays.map((birthday) => (
          <BirthdayCard key={birthday.id} birthday={birthday} />
        ))}
      </div>
    </div>
  );
}
